import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import UsersTable from '../../components/UsersTable';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: "30px 0" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Users({ authority }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        style={{
          fontSize: "30px",
          color: "#010004",
          textAlign: "center",
        }}
      >
        الطلبة
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' , padding:0 }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab sx={{ fontSize: 20 }} label="الصف الاول الثانوي" {...a11yProps(0)} />
          <Tab sx={{ fontSize: 20 }} label="الصف الثاني الثانوي" {...a11yProps(1)} />
          <Tab sx={{ fontSize: 20 }} label="الصف الثالث الثانوي" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}> 
        <UsersTable authority={authority} academicYear={"H1"}/>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <UsersTable authority={authority} academicYear={"H2"}/>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <UsersTable authority={authority} academicYear={"H3"}/>
      </CustomTabPanel>

    </Box>
  );
}
